export const parseLabelList = (labelList) => {
    const split = labelList?.split("#") || [];

    return {
        position: split[0] || "",
        angle: split[1] ? +split[1] : 0,
    };
};
